import React, { FC } from 'react';
import { FormField as LegacyFormField } from './component.legacy';
import { FormField as NewFormField, FormFieldProps } from './component';

interface FormFieldWithBridge extends FormFieldProps {
  renderAsLegacy?: boolean;
}

/**
 * FormField bridge component.
 * - renderAsLegacy={true} (default): uses the original class-based implementation
 * - renderAsLegacy={false}: uses the new functional implementation with Core.FormLabel
 */
export const FormField: FC<FormFieldWithBridge> = ({ renderAsLegacy = true, ...restProps }) => {
  const Component = (renderAsLegacy ? LegacyFormField : NewFormField) as React.ComponentType<FormFieldWithBridge>;
  return <Component {...restProps} renderAsLegacy={renderAsLegacy} />;
};

FormField.displayName = 'FormFieldBridge';
